"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function SystemsMenuToggle({ onClick, isOpen }) {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { "$flashOnClick": true, onClick: onClick, "$isOpen": isOpen, "data-e2e": 'SystemsMenuToggle_StyledButton', children: [(0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'SystemsMenuToggle_Text', children: t(i18n_1.Strings.systemsMenu.systems) }), (0, jsx_runtime_1.jsx)(ui_1.Minimise, { onClick: onClick, isSelected: isOpen, flashOnClick: true, "data-e2e": 'SystemsMenuToggle_Minimise' })] }));
}
exports.default = SystemsMenuToggle;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  font-weight: 400;
  background-color: ${({ theme }) => theme.grasshopper.background};
  width: 168px;
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 0;
  opacity: 0.9;

  z-index: 9;

  ${({ $isOpen }) => $isOpen &&
    (0, styled_components_1.css) `
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    `}

  &:hover {
    svg {
      color: ${({ theme }) => theme.grasshopper.text.white};
    }
  }
`;
const Text = styled_components_1.default.div `
  font-size: 20px;
  font-family: 'Elsevier Sans';
  margin-left: 16px;
`;
